import { render, staticRenderFns } from "./ManagerEditLayer.vue?vue&type=template&id=270534dc&scoped=true&"
import script from "./ManagerEditLayer.vue?vue&type=script&lang=js&"
export * from "./ManagerEditLayer.vue?vue&type=script&lang=js&"
import style0 from "./ManagerEditLayer.vue?vue&type=style&index=0&id=270534dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270534dc",
  null
  
)

export default component.exports